// extracted by mini-css-extract-plugin
export default {"header":"mainSection_header__eIFbK","filtersContainer":"mainSection_filtersContainer__72NCS","wrapper":"mainSection_wrapper__8Mspj"};